<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="data"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :outlined="outlined"
        v-model="data"
        :label="label"
        prepend-inner-icon="mdi-calendar-month-outline"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="data" type="month" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(data)">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      default: () => new Date().toISOString().substr(0, 7)
    },
    label: {
      default: 'Date'
    },
    outlined: {
      default: false
    }
  },
  data() {
    return {
      data: this.value,
      menu: false
    }
  },
  watch: {
    value(newVal) {
      this.data = newVal
    },
    data(newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>

<style></style>
